import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var CurrencyTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(CurrencyTransformer, _BaseTransformer);
  var _super = _createSuper(CurrencyTransformer);
  function CurrencyTransformer() {
    _classCallCheck(this, CurrencyTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(CurrencyTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        abbr: data.abbr,
        code: data.code,
        value: data.currency_id,
        label: data.label,
        defaultRateType: data.default_rate_type,
        rate: data.rate,
        default: data.is_default,
        status: data.status
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return CurrencyTransformer;
}(BaseTransformer);